/**
 * Application Routes Configuration
 */

export const ROUTES = {
  HOME: '/',
  COURSE_OVERVIEW: '/course/:courseId',
  LEARNING_SESSION: '/course/:courseId/learn',
  QUESTION_PRACTICE: '/course/:courseId/questions',
  FLASHCARDS: '/course/:courseId/flashcards',
  REVIEW_CONTENT: '/course/:courseId/review',
  ADAPTIVE_SESSION: '/course/:courseId/adaptive',
  DASHBOARD: '/dashboard',
  SETTINGS: '/settings',
  ADMIN_ROOT: '/admin',
  ADMIN_COURSES: '/admin/courses',
  ADMIN_COURSE_DETAIL: '/admin/courses/:courseId',
  ADMIN_QUESTIONS: '/admin/questions',
  ADMIN_USERS: '/admin/users',
  ADMIN_BRANDING: '/admin/branding',
  ADMIN_EMAILS: '/admin/emails',
  ADMIN_EMAIL_LOGS: '/admin/email-logs',
  ADMIN_EMAIL_CONFIG: '/admin/email-config',
};

/**
 * Generate route path with parameters
 * @param {string} route - Route template
 * @param {Object} params - Route parameters
 * @returns {string} - Generated route
 */
export function generatePath(route, params = {}) {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
}
